/* tslint:disable */
/* eslint-disable */
/**
 * OneAir.AdminPortal
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import {
    Location,
    LocationFromJSON,
    LocationFromJSONTyped,
    LocationToJSON,
    Station,
    StationFromJSON,
    StationFromJSONTyped,
    StationToJSON,
} from './';

/**
 * 
 * @export
 * @interface StationOrLocation
 */
export interface StationOrLocation {
    /**
     * 
     * @type {Station}
     * @memberof StationOrLocation
     */
    station?: Station;
    /**
     * 
     * @type {Location}
     * @memberof StationOrLocation
     */
    location?: Location;
    /**
     * 
     * @type {string}
     * @memberof StationOrLocation
     */
    readonly iataCode?: string | null;
    /**
     * 
     * @type {string}
     * @memberof StationOrLocation
     */
    readonly label?: string | null;
}

export function StationOrLocationFromJSON(json: any): StationOrLocation {
    return StationOrLocationFromJSONTyped(json, false);
}

export function StationOrLocationFromJSONTyped(json: any, ignoreDiscriminator: boolean): StationOrLocation {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'station': !exists(json, 'station') ? undefined : StationFromJSON(json['station']),
        'location': !exists(json, 'location') ? undefined : LocationFromJSON(json['location']),
        'iataCode': !exists(json, 'iataCode') ? undefined : json['iataCode'],
        'label': !exists(json, 'label') ? undefined : json['label'],
    };
}

export function StationOrLocationToJSON(value?: StationOrLocation | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'station': StationToJSON(value.station),
        'location': LocationToJSON(value.location),
    };
}


